import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import './App.css';

function App() {
  const [url, setUrl] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [stats, setStats] = useState(null);
  const [copied, setCopied] = useState(false);
  const [bypassTime, setBypassTime] = useState(null);
  const [isApiKey, setIsApiKey] = useState(false);
  const [captchaToken, setCaptchaToken] = useState(null);
  const [apiKey, setApiKey] = useState(null);
  const [hasApiKey, setHasApiKey] = useState(false);

  const [cooldownActive, setCooldownActive] = useState(false);
  const [cooldownMessage, setCooldownMessage] = useState('');
  const [progressMessage, setProgressMessage] = useState('');
  const [progressPercent, setProgressPercent] = useState(0);
  const captchaRef = useRef(null);
  const bannerAdLoaded = useRef(false);
  const verticalBannerLoaded = useRef(false);
  const verticalBannerRightLoaded = useRef(false);
  const API_BASE = 'https://ko.flazu.my';
  const HCAPTCHA_SITE_KEY = '21045614-e5b6-4532-837e-81d24b1203d4';
  const COOLDOWN_SECONDS = 10;
  const ENABLE_COOLDOWN = true;
  const POLL_INTERVAL = 3000;
  const MAX_POLL_TIME = 300000;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchStats();
    
    const params = new URLSearchParams(window.location.search);
    const keyParam = params.get('key');
    const linkParam = params.get('link');
    
    if (linkParam) {
      setUrl(decodeURIComponent(linkParam));
    }
    
    if (keyParam) {
      setApiKey(keyParam);
      verifyApiKey(keyParam, linkParam);
    }

    if (!bannerAdLoaded.current) {
      setTimeout(() => {
        const container = document.getElementById('banner-ad-container');
        if (container) {
          console.log('Loading center banner 728x90...');
          window.atOptions = {
            'key' : '828f0271e3091a0f2de7db516e138af3',
            'format' : 'iframe',
            'height' : 90,
            'width' : 728,
            'params' : {}
          };
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = '//cheaperredressrationally.com/828f0271e3091a0f2de7db516e138af3/invoke.js';
          script.onload = () => console.log('Center banner loaded');
          script.onerror = () => console.error('Center banner failed');
          container.appendChild(script);
        } else {
          console.error('Center banner container not found');
        }
      }, 1000);
      bannerAdLoaded.current = true;
    }

    if (!verticalBannerLoaded.current) {
      setTimeout(() => {
        const container = document.getElementById('vertical-banner-left');
        if (container) {
          console.log('Loading left banner 160x600...');
          window.atOptions_vertical_left = {
            'key' : '0fe2f85d5dbadf22fa0a01d93fb20458',
            'format' : 'iframe',
            'height' : 600,
            'width' : 160,
            'params' : {}
          };
          
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = '//cheaperredressrationally.com/0fe2f85d5dbadf22fa0a01d93fb20458/invoke.js';
          script.onload = () => console.log('Left banner loaded');
          script.onerror = () => console.error('Left banner failed');
          container.appendChild(script);
        } else {
          console.error('Left banner container not found');
        }
      }, 1200);
      verticalBannerLoaded.current = true;
    }

    if (!verticalBannerRightLoaded.current) {
      setTimeout(() => {
        const container = document.getElementById('vertical-banner-right');
        if (container) {
          console.log('Loading right banner 160x600...');
          window.atOptions_vertical_right = {
            'key' : '0fe2f85d5dbadf22fa0a01d93fb20458',
            'format' : 'iframe',
            'height' : 600,
            'width' : 160,
            'params' : {}
          };
          
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = '//cheaperredressrationally.com/0fe2f85d5dbadf22fa0a01d93fb20458/invoke.js';
          script.onload = () => console.log('Right banner loaded');
          script.onerror = () => console.error('Right banner failed');
          container.appendChild(script);
        } else {
          console.error('Right banner container not found');
        }
      }, 1400);
      verticalBannerRightLoaded.current = true;
    }
  }, []);



  const verifyApiKey = async (key, link) => {
    try {
      const response = await axios.get(
        `${API_BASE}/verify-key?key=${encodeURIComponent(key)}`
      );
      
      if (response.data.valid) {
        setHasApiKey(true);
        
        if (link) {
          setTimeout(() => {
            const form = document.querySelector('form');
            if (form) {
              form.requestSubmit();
            }
          }, 800);
        }
      } else {
        setHasApiKey(false);
        setError('Invalid API key');
      }
    } catch (err) {
      setHasApiKey(false);
      setError('Failed to verify API key');
    }
  };

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_BASE}/`);
      setStats(response.data);
    } catch (err) {
      console.error('Failed to fetch stats:', err);
    }
  };

  const startCooldown = (service = '') => {
    return new Promise((resolve) => {
      const isLinkvertise = service.toLowerCase().includes('linkvertise');
      
      if (!isLinkvertise || !ENABLE_COOLDOWN || COOLDOWN_SECONDS <= 0) {
        resolve();
        return;
      }
      
      setCooldownActive(true);
      setCooldownMessage('⚠️ Linkvertise detected! Please wait 10 seconds to avoid Luarmor detection...');
      let remaining = COOLDOWN_SECONDS;
      
      const interval = setInterval(() => {
        remaining--;
        
        if (remaining <= 0) {
          clearInterval(interval);
          setCooldownActive(false);
          resolve();
        }
      }, 1000);
      
      window.skipCooldown = () => {
        clearInterval(interval);
        setCooldownActive(false);
        delete window.skipCooldown;
        resolve();
      };
    });
  };
  
  const pollTaskStatus = async (taskId, headers = {}) => {
    const startTime = Date.now();
    
    return new Promise((resolve, reject) => {
      const checkStatus = async () => {
        if (Date.now() - startTime > MAX_POLL_TIME) {
          reject(new Error('Polling timeout after 2 minutes'));
          return;
        }
        
        try {
          const response = await axios.get(`${API_BASE}/v1/free/bypass/async/${taskId}`, { headers });
          const data = response.data;
          
          if (data.message) {
            setProgressMessage(data.message);
          }
          
          const elapsed = Date.now() - startTime;
          const estimatedProgress = Math.min(90, 20 + (elapsed / 30000) * 70);
          setProgressPercent(Math.round(estimatedProgress));
          
          if (data.status === 'completed' && data.result) {
            setProgressPercent(100);
            resolve(data);
          } else if (data.status === 'failed') {
            reject(new Error(data.error || 'Task failed'));
          } else if (data.status === 'processing') {
            setTimeout(checkStatus, POLL_INTERVAL);
          } else {
            setTimeout(checkStatus, POLL_INTERVAL);
          }
        } catch (err) {
          if (err.response?.status === 404) {
            reject(new Error('Task not found or expired'));
          } else {
            reject(err);
          }
        }
      };
      
      checkStatus();
    });
  };
  
  const handleBypass = async (e) => {
    e.preventDefault();
    
    if (!hasApiKey && !captchaToken) {
      setError('Please complete the captcha verification');
      return;
    }
    
    setLoading(true);
    setError('');
    setResult(null);
    setCopied(false);
    setBypassTime(null);
    setProgressPercent(0);
    setProgressMessage('');
    
    const detectedService = url.toLowerCase().includes('linkvertise') ? 'Linkvertise' : '';
    
    if (ENABLE_COOLDOWN && detectedService) {
      await startCooldown(detectedService);
    }

    try {
      setProgressMessage('Connecting to API...');
      setProgressPercent(10);
      
      const params = new URLSearchParams();
      params.append('link', url);
      
      if (apiKey) {
        params.append('key', apiKey);
      }
      
      const requestUrl = `${API_BASE}/v1/free/bypass?${params.toString()}`;
      
      const headers = {};
      
      if (!hasApiKey && captchaToken) {
        headers['X-Captcha-Token'] = captchaToken;
      }
      
      const response = await axios.get(requestUrl, { headers });
      
      console.log('API Response:', response.data);
      console.log('Status check:', response.data.status, 'Task ID:', response.data.task_id);
      console.log('Is processing?', response.data.status === 'processing');
      console.log('Has task_id?', !!response.data.task_id);
      
      if (response.data.status === 'processing' && response.data.task_id) {
        console.log('Starting async polling for task:', response.data.task_id);
        const estimatedTime = response.data.estimated_time || '15-30s';
        const service = response.data.service || 'Service';
        
        setError('');
        setProgressMessage(`Processing ${service}... (${estimatedTime})`);
        setProgressPercent(20);
        
        try {
          const taskResult = await pollTaskStatus(response.data.task_id, headers);
          const finalUrl = taskResult.result;
          
          if (!finalUrl) {
            throw new Error('No result from task');
          }
          
          setProgressMessage('Bypass completed!');
          setProgressPercent(100);
          setResult(finalUrl);
          setIsApiKey(false);
          if (!hasApiKey) {
            window.open('https://chapturnjut.com/heiqsxtc7?key=0716beb7236e3f3ee54289bf65bc7bde', '_blank');
          }
          
          if (taskResult.time) {
            setBypassTime(taskResult.time.replace('s', ''));
          }
          
          if (!hasApiKey) {
            setCaptchaToken(null);
            if (captchaRef.current) {
              captchaRef.current.resetCaptcha();
            }
          }
        } catch (pollErr) {
          console.error('Polling error:', pollErr);
          throw new Error('Failed to get result: ' + (pollErr.message || 'Unknown error'));
        }
      }
      else if (response.data.status === 'success') {
        const hasKey = response.data.key && !response.data.redirect;
        const resultData = response.data.redirect || response.data.key;
        
        setProgressMessage('Bypass completed!');
        setProgressPercent(100);
        setResult(resultData);
        setIsApiKey(hasKey);
        if (!hasApiKey) {
          window.open('https://chapturnjut.com/heiqsxtc7?key=0716beb7236e3f3ee54289bf65bc7bde', '_blank');
        }
        
        const apiTime = response.data.time;
        if (apiTime) {
          setBypassTime(apiTime.replace('s', ''));
        }
        
        if (!hasApiKey) {
          setCaptchaToken(null);
          if (captchaRef.current) {
            captchaRef.current.resetCaptcha();
          }
        }
      }
      else if (response.data.status === 'error' || response.data.status === 'failed') {
        throw new Error(response.data.message || 'Bypass failed');
      }
      else {
        throw new Error('Unexpected response format');
      }
    } catch (err) {
      console.error('Bypass error:', err);
      const errorMsg = err.message || err.response?.data?.message || 'Unknown error';
      setError(errorMsg);
      setProgressMessage('');
      setProgressPercent(0);
      
      if (!hasApiKey) {
        setCaptchaToken(null);
        if (captchaRef.current) {
          captchaRef.current.resetCaptcha();
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(result);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    window.open('https://cheaperredressrationally.com/wx3gubif7?key=bd5c194e9f5ec6f0b10c5541b3c9f433', '_blank');
  };

  const handleVisitLink = () => {
    window.open(result, '_blank');
  };

  return (
    <div className="App">
      <header className="hero">
        <div className="container">
          <img src="/F.png" alt="Flazu Bypass" className="hero-logo" />
        </div>
      </header>

      <section className="bypass-section">
        <div className="container">
          <div className="bypass-card">
            <form onSubmit={handleBypass}>
              <div className="modern-input-group">
                <input
                  type="url"
                  value={url}
                  onChange={(e) => setUrl(e.target.value)}
                  placeholder="Enter shortened URL"
                  required
                  disabled={loading}
                  autoFocus={false}
                  className="modern-input"
                />
                <button type="submit" disabled={loading || (!hasApiKey && !captchaToken)} className="modern-btn">
                  {loading ? (
                    <>
                      <span className="spinner"></span>
                      Processing
                    </>
                  ) : (
                    'Get Link'
                  )}
                </button>
              </div>
              
              {!hasApiKey && (
                <div className="captcha-wrapper">
                  <HCaptcha
                    ref={captchaRef}
                    sitekey={HCAPTCHA_SITE_KEY}
                    onVerify={(token) => {
                      setCaptchaToken(token);
                      if (url) {
                        setTimeout(() => {
                          const form = document.querySelector('form');
                          if (form) {
                            form.requestSubmit();
                          }
                        }, 300);
                      }
                    }}
                    onExpire={() => setCaptchaToken(null)}
                    onError={() => setCaptchaToken(null)}
                  />
                </div>
              )}
              
              {hasApiKey && (
                <div className="api-key-badge">
                  API Key Active - Captcha Bypassed
                </div>
              )}
            </form>

            {cooldownActive && (
              <div className="cooldown-box">
                <p className="cooldown-message">{cooldownMessage}</p>
                <button 
                  type="button"
                  onClick={() => window.skipCooldown && window.skipCooldown()}
                  className="skip-cooldown-btn"
                >
                  Continue
                </button>
              </div>
            )}
            
            {loading && progressMessage && (
              <div className="progress-box">
                <p className="progress-message">{progressMessage}</p>
                <div className="progress-bar-container">
                  <div className="progress-bar-fill" style={{width: `${progressPercent}%`}}></div>
                </div>
                <p className="progress-percent">{progressPercent}%</p>
              </div>
            )}
            
            {error && (
              <div className="alert alert-error">
                <div className="alert-content">
                  <strong>Request Failed</strong>
                  <p>{error}</p>
                </div>
              </div>
            )}

            {result && (
              <div className="result-box">
                <div className="result-header">
                  <div>
                    <h3>{isApiKey ? 'API Key Generated' : 'Link Retrieved'}</h3>
                    {bypassTime && (
                      <p className="bypass-time">{bypassTime}s</p>
                    )}
                  </div>
                </div>
                
                <div className="result-link">
                  <input type="text" value={result} readOnly />
                  <button onClick={copyToClipboard} className={`copy-btn ${copied ? 'copied' : ''}`}>
                    {copied ? 'Copied' : 'Copy'}
                  </button>
                </div>
                
                <button onClick={handleVisitLink} className="open-link-btn">
                  Visit Link
                </button>
              </div>
            )}
          </div>
        </div>
      </section>

      <section className="support-list" id="support">
        <div className="container">
          <h2 className="section-title">Supported Services</h2>
          <div className="support-grid">
            <div className="support-card">
              <div className="support-header">
                <h3>work.ink</h3>
                <span className="status-badge online">Active</span>
              </div>
              <p className="support-desc">Undetected Luarmor / Volcano</p>
            </div>

            <div className="support-card">
              <div className="support-header">
                <h3>Linkvertise</h3>
                <span className="status-badge online">Active</span>
              </div>
              <p className="support-desc">Undetected Luarmor</p>
            </div>

            <div className="support-card">
              <div className="support-header">
                <h3>Loot-Labs</h3>
                <span className="status-badge online">Active</span>
              </div>
              <p className="support-desc">Undetected Luarmor</p>
            </div>

            <div className="support-card">
              <div className="support-header">
                <h3>Platoboost</h3>
                <span className="status-badge online">Active</span>
              </div>
              <p className="support-desc">Auto Key Generation</p>
            </div>
          </div>
        </div>
      </section>

      <section className="statistics" id="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-content">
                <div className="stat-value">
                  {stats ? (
                    <span className={`status-badge ${stats.status === 'online' ? 'online' : 'offline'}`}>
                      {stats.status}
                    </span>
                  ) : 'Loading...'}
                </div>
                <div className="stat-label">API Status</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-content">
                <div className="stat-value">{stats?.uptime || '---'}</div>
                <div className="stat-label">Uptime</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-content">
                <div className="stat-value">3+</div>
                <div className="stat-label">Services</div>
              </div>
            </div>
            
            <div className="stat-card">
              <div className="stat-content">
                <div className="stat-value">24/7</div>
                <div className="stat-label">Available</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ad-section-combined">
        <div className="container">
          <div className="ad-flex-container">
            <div className="ad-vertical-container" id="vertical-banner-left"></div>
            <div className="ad-container" id="banner-ad-container"></div>
            <div className="ad-vertical-container" id="vertical-banner-right"></div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <a 
            href="https://discord.gg/sYFqDTDvCr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="discord-btn"
          >
            <svg width="24" height="24" viewBox="0 0 127.14 96.36" fill="currentColor">
              <path d="M107.7,8.07A105.15,105.15,0,0,0,81.47,0a72.06,72.06,0,0,0-3.36,6.83A97.68,97.68,0,0,0,49,6.83,72.37,72.37,0,0,0,45.64,0,105.89,105.89,0,0,0,19.39,8.09C2.79,32.65-1.71,56.6.54,80.21h0A105.73,105.73,0,0,0,32.71,96.36,77.7,77.7,0,0,0,39.6,85.25a68.42,68.42,0,0,1-10.85-5.18c.91-.66,1.8-1.34,2.66-2a75.57,75.57,0,0,0,64.32,0c.87.71,1.76,1.39,2.66,2a68.68,68.68,0,0,1-10.87,5.19,77,77,0,0,0,6.89,11.1A105.25,105.25,0,0,0,126.6,80.22h0C129.24,52.84,122.09,29.11,107.7,8.07ZM42.45,65.69C36.18,65.69,31,60,31,53s5-12.74,11.43-12.74S54,46,53.89,53,48.84,65.69,42.45,65.69Zm42.24,0C78.41,65.69,73.25,60,73.25,53s5-12.74,11.44-12.74S96.23,46,96.12,53,91.08,65.69,84.69,65.69Z"/>
            </svg>
            Join Discord
          </a>
          <p>© 2025 Flazu Bypass. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
